import moment from 'moment';

export const momentDates = data => Array.isArray(data) ? data.map(momentDates) : {
    ...data,
    dateInscription: moment(data.dateInscription.date)
};

export default {momentDates};